"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VisitorDirection = void 0;
var VisitorDirection;
(function (VisitorDirection) {
    VisitorDirection["Enter"] = "enter";
    VisitorDirection["Leave"] = "leave";
})(VisitorDirection = exports.VisitorDirection || (exports.VisitorDirection = {}));
